// 站点级 SEO 关键字与描述（用于各页面默认值与首页）
const SITE_KEYWORDS = '邻话,邻话网,邻话社区,校园社区,大学生社区,校园生活,校园八卦,大学生感情,找搭子,考研,二手交易,失物招领,校园吐槽,同校交流,校园论坛'
const SITE_DESCRIPTION = '邻话（邻话网）是面向大学生的校园社交分享社区，发现校园生活的美好，分享你的每一个精彩瞬间。在这里聊八卦、谈感情、找搭子、备考考研、做二手交易、发布失物招领，畅快吐槽。'

const routes = [
  {
    path: "/",
    component: () => import('@/components/layout/index.vue'),
    meta: {
      title: "邻话 - 发现校园生活的美好，分享你的每一个精彩瞬间",
      description: SITE_DESCRIPTION,
      keywords: SITE_KEYWORDS
    },
    children: [
      {
        path: "/",
        component: () => import('@/view/home/index.vue'),
        meta: {
          title: "邻话 - 校园社交分享社区｜八卦·感情·搭子·考研·二手·失物·吐槽",
          description: SITE_DESCRIPTION,
          keywords: SITE_KEYWORDS
        }
      },

      {
        path: "/add",
        component: () => import('@/view/add/index'),
        meta: {
          title: "发布动态 - 邻话",
          description: '在邻话发布校园动态、二手转让、失物招领、找搭子、吐槽与情感话题。',
          keywords: '邻话,发布动态,发帖,校园发帖,二手发布,找搭子,失物招领发布'
        }
      },

      {
        path: "/category",
        component: () => import('@/view/category/index.vue'),
        meta: {
          title: "文章分类 - 邻话",
          description: '邻话社区分类导航：八卦、感情、搭子、考研、二手交易、失物招领、吐槽。',
          keywords: '邻话,分类,文章分类,校园八卦,大学生感情,找搭子,考研,二手交易,失物招领,吐槽'
        }
      },
      {
        path: "/say",
        component: () => import('@/view/say/index'),
        meta: {
          title: "同校 - 邻话",
          description: '邻话同校，分享校园里的每一个精彩瞬间，吐槽、感情、生活随手记。',
          keywords: '邻话,同校说说,校园说说,大学生说说,吐槽'
        }
      },
      {
        path: "/im",
        component: () => import('@/view/im/index'),
        meta: {
          title: "私信 - 邻话",
          description: '邻话私信中心。',
          keywords: '邻话,私信,聊天'
        }
      },
      {
        path: "/search",
        component: () => import('@/view/search/index.vue'),
        meta: {
          title: "搜索 - 邻话",
          description: '在邻话搜索帖子、说说、二手商品、失物招领、考研经验等校园内容。',
          keywords: '邻话,搜索,校园搜索,帖子搜索'
        }
      },
      {
        path: "/hot",
        component: () => import('@/view/search/Hot.vue'),
        meta: {
          title: "热搜榜 - 邻话",
          description: '邻话热搜榜，实时关注校园热议话题、同校热搜与热门帖子。',
          keywords: '邻话,热搜,校园热搜,同校热搜,热门话题,热议'
        }
      },
      {
        name: "notice",
        path: "/notice",
        component: () => import("@/view/notice/index.vue"),
        meta: {
          title: "消息通知 - 邻话",
          description: '邻话消息通知中心。',
          keywords: '邻话,消息,通知'
        }
      },
      {
        path: "/navigation",
        component: () => import('@/view/navigation/index.vue'),
        meta: {
          title: "网站导航 - 邻话",
          description: '邻话网站导航，快速直达常用栏目与功能。',
          keywords: '邻话,网站导航,导航'
        }
      },
      {
        path: "/app",
        component: () => import('@/view/app/index.vue'),
        meta: {
          title: "下载邻话 App - 邻话",
          description: '下载邻话 App，随时随地参与校园社交，发现身边的精彩生活。',
          keywords: '邻话,邻话App,邻话下载,校园App,大学生App'
        }
      },
      {
        path: "/campus-ambassador",
        component: () => import('@/view/campus-ambassador/index.vue'),
        meta: {
          title: "校园大使报名 - 邻话",
          description: '邻话校园大使招募中。一起把邻话带进每一所校园，赢取专属福利、积累运营经验、结识全国校园伙伴。',
          keywords: '邻话,校园大使,校园合伙人,大学生兼职,校园招募,邻话大使'
        }
      },
      {
        // 帖子详情页：App 分享海报中的二维码指向这里，未登录也可浏览
        path: "/article/:id",
        component: () => import('@/view/article/detail.vue'),
        meta: {
          title: "帖子详情 - 邻话",
          description: '查看邻话社区的校园帖子内容、图片与评论。',
          keywords: '邻话,帖子详情,校园帖子,校园社区,大学生社区'
        }
      },
      {
        // 视频落地页：分享出去的视频帖链接、/article/:id 发现是视频帖时转到这里，未登录也可观看。
        // 站内点视频走全局播放器弹层（components/video/VideoViewerHost），不跳这个路由
        path: "/video/:id",
        component: () => import('@/view/video/index.vue'),
        meta: {
          title: "视频 - 邻话",
          description: '在邻话观看校园视频，点赞、评论、分享给同学。',
          keywords: '邻话,校园视频,大学生视频,校园社区'
        }
      },
      {
        path: "/group/join/:token",
        component: () => import('@/view/group/join.vue'),
        meta: {
          title: "加入群聊 - 邻话",
          description: '通过邀请加入邻话群聊。',
          keywords: '邻话,群聊,加入群聊'
        }
      },
      {
        path: "/user/:userId",
        component: () => import('@/view/user/index.vue'),
        meta: {
          title: "用户主页 - 邻话",
          description: '查看邻话用户的个人主页、动态与帖子。',
          keywords: '邻话,用户主页,个人主页,校园社交'
        }
      },
      {
        // 账号设置：聚合修改个人信息 / 修改密码 / 认证学校 / 隐私设置。
        // 需要登录才有内容，但不加路由守卫（本项目的登录拦截一律在入口处做），
        // 页面自己在未登录时渲染登录引导
        path: "/account-settings",
        component: () => import('@/view/account-settings/index.vue'),
        meta: {
          title: "账号设置 - 邻话",
          description: '管理邻话账号的个人信息、登录密码、学校认证与隐私设置。',
          keywords: '邻话,账号设置,个人信息,修改密码,学校认证,隐私设置'
        }
      },
      // 私密账号的关注申请没有独立路由：它合并进了 /notice?type=2「收到的关注」，
      // 后端在那一栏同时返回 noticeType 2（关注了你）和 7（请求关注你），
      // 申请那一行多一组「通过 / 拒绝」按钮 —— 与抖音「新关注我的」一致。
    ],
  },
  {
    path: "/privacy",
    component: () => import('@/view/privacy/index.vue'),
    meta: {
      title: "用户协议 - 邻话",
      description: '邻话用户协议。',
      keywords: '邻话,用户协议'
    }
  },
  {
    path: "/privacy-policy",
    component: () => import('@/view/privacy/privacy-policy.vue'),
    meta: {
      title: "隐私政策 - 邻话",
      description: '邻话隐私政策。',
      keywords: '邻话,隐私政策'
    }
  },
  {
    path: "/children-privacy-policy",
    component: () => import('@/view/privacy/children-privacy-policy.vue'),
    meta: {
      title: "儿童隐私保护声明 - 邻话",
      description: '邻话儿童隐私保护声明，适用于不满十四周岁的儿童及其监护人。',
      keywords: '邻话,儿童隐私保护声明,未成年人保护,儿童隐私'
    }
  },
  {
    path: "*",
    name: "NotFound",
    component: () => import("@/view/404/404.vue"),
    meta: {
      title: "页面未找到 - 邻话",
      description: '抱歉，您访问的页面不存在。',
      keywords: '邻话,404'
    }
  }
]
export default routes
